import en from "./en.json";
import ar from "./ar.json";
import es from "./es.json";
import pt from "./pt.json";

export default {
  en: { translation: en },
  ar: { translation: ar },
  es: { translation: es },
  pt: { translation: pt },
};
